import { Breadcrumb, Button, Card, Col, Flex, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormInput } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const SettingTimesheetCreateRole = (
    {
        onSubmit = () => { }
    }
) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const navigate = useNavigate();

    return (
        <MainLayout>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Breadcrumb items={[
                    { title: t("home.header"), href: "/" },
                    { title: t("setting_timesheet.header"), href: "/setting_timesheet/masterdata" },
                    { title: t("masterdata.header"), href: "/setting_timesheet/masterdata" },
                    { title: t("setting_timesheet.label.manage_role"), href: "/setting_timesheet/masterdata" },
                    { title: t("setting_timesheet.label.create_role") },
                ]} />

                <Card
                    style={{
                        backgroundColor: "white",
                        width: "100%",
                        boxShadow: '0px 4px 2px 0px rgba(0, 0, 0, 0.15)',
                        borderRadius: "20px"
                    }}
                >
                    <FormAntd
                        form={form}
                        onFinish={onSubmit}
                    >
                        <FormItem shouldUpdate>
                            {({ getFieldsValue, getFieldValue, setFieldValue, resetFields }) => {
                                return (
                                    <Space size={16} direction="vertical" style={{ width: "100%" }}>
                                        <Flex vertical>
                                            <h2>{t("setting_timesheet.label.create_role")}</h2>
                                            <span style={{ color: "#667085" }}>{t("setting_notification.detail_3")}</span>
                                        </Flex>

                                        <Row justify={"space-between"}>
                                            <Col span={11}>
                                                <FormInput
                                                    name="roleCode"
                                                    label={t("setting_timesheet.label.roleId")}
                                                    size="large"
                                                    required
                                                />
                                            </Col>

                                            {/* <Col span={11}>
                                                <FormInput
                                                    name="roleName"
                                                    label={t("setting_timesheet.label.roleName")}
                                                    size="large"
                                                    required
                                                />
                                            </Col> */}
                                        </Row>

                                        <Row justify={"space-between"}>
                                            <Col span={11}>
                                                <FormInput
                                                    name="roleName"
                                                    label={t("setting_timesheet.label.roleName")}
                                                    size="large"
                                                    required
                                                />
                                            </Col>

                                            <Col span={11}>
                                                <FormInput
                                                    name="roleNameEn"
                                                    label={t("setting_timesheet.label.roleNameEn")}
                                                    size="large"
                                                    required
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col span={24}>
                                                <FormInput
                                                    name="description"
                                                    label={t("employee.label.description")}
                                                    placeholder={t("common.explain_further")}
                                                    size="large"
                                                    required
                                                    type="textArea"
                                                />
                                            </Col>
                                        </Row>

                                        <Row justify="end" style={{ gap: "12px", paddingTop: "48px" }}>
                                            <Button type="default"
                                                style={{ height: "40px", borderRadius: "8px", color: "#565656", fontWeight: "bold" }}
                                                onClick={() => {
                                                    resetFields()
                                                    navigate("/setting_timesheet/masterdata")
                                                }}
                                            >
                                                {t("common.cancel").toUpperCase()}
                                            </Button>

                                            <Button type="primary" htmlType="submit"
                                                style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", color: "white", fontWeight: "bold" }}
                                            >
                                                {t("common.submit").toUpperCase()}
                                            </Button>
                                        </Row>
                                    </Space>
                                )
                            }}
                        </FormItem>
                    </FormAntd>
                </Card>
            </Space>
        </MainLayout>
    )
}

export default SettingTimesheetCreateRole;